module.exports = require("@swa-ui/core/src/AnchorTarget/AnchorTarget.module.scss");